import React from 'react';
import Icon from './Icon';

const Standings = ({ players, onBack }) => {
  return (
    <div className="min-h-screen p-4">
      <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
        <Icon d="M15 19l-7-7 7-7" />
        Retour
      </button>

      <h1 className="text-2xl font-bold mb-4">Classement</h1>

      <div className="space-y-2">
        {players.filter(p => !p.dropped).map((player, idx) => (
          <div key={player.id} className="bg-gray-800 p-4 rounded-lg">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <div className={`text-2xl font-bold ${idx === 0 ? 'text-yellow-400' : idx === 1 ? 'text-gray-300' : idx === 2 ? 'text-orange-400' : 'text-gray-500'}`}>
                  #{idx + 1}
                </div>
                <div>
                  <div className="font-semibold">{player.name}</div>
                  <div className="text-sm text-gray-400">
                    {player.matchWins}-{player.matchLosses}-{player.matchDraws}
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-xl font-bold">{player.matchPoints} pts</div>
                <div className="text-xs text-gray-400">
                  OMW: {(player.omw * 100).toFixed(1)}%
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Standings;